import Typography from "@mui/material/Typography";
import { TableRow } from "./GenericInformationTable";
import { ExpandableContent } from "./ExpandableContent";
import BlurredTypograhy from "../typograhy/BlurredTypograhy";

/**
 * Inline component for ExpandableContent.
 * Replace or remove if you already have a separate ExpandableContent file.
 */

interface RowCellsProps {
    row?: TableRow;
    handleShowMore: (content: string) => void;
    isFullView: boolean;
}

/**
 * RowCells is responsible for rendering a single table "cell" within a row.
 * It handles:
 * - The fieldName (row.fieldName)
 * - A value that may be "expandable" if longer than 100 chars
 */
function RowCell({ row, handleShowMore, isFullView }: Readonly<RowCellsProps>) {
    // If row is undefined or null, return nothing
    if (!row) {
        return null;
    }

    const { fieldName, value, isExpandable, isDataShowable } = row;

    //If content length is more then 100 then Expandable icon will be aviable
    const showExpandable = isExpandable && value && value.length > 100;

    return (
        <div className="generic-information-table-cell">
            {isDataShowable != false ? (
                <>
                    <Typography>{fieldName}</Typography>
                    <Typography>
                        {showExpandable ? (
                            <ExpandableContent
                                value={value || ""}
                                shortLenth={isFullView ? 92 : 50}
                                onShowMore={handleShowMore}
                            />
                        ) : (
                            <input
                            type="text"
                            value={value || ""}
                            placeholder="N/A"
                            readOnly
                            className="generic-information-table-input"
                          />
                                    )}
                    </Typography>
                </>
            ) : (
                <BlurredTypograhy />
            )}
        </div>
    );
}

export default RowCell;
